import React from 'react';
import NationalRoad2023 from 'views/NationalRoad2023';

const LifeSkillPage = () => {
  return <NationalRoad2023/>;
};

export default LifeSkillPage;